import { render, staticRenderFns } from "./Fangkuai.vue?vue&type=template&id=524a68b6&"
import script from "./Fangkuai.vue?vue&type=script&lang=js&"
export * from "./Fangkuai.vue?vue&type=script&lang=js&"
import style0 from "./Fangkuai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports